import {
  Component,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { NzInputModule } from 'ng-zorro-antd/input';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddressDetails } from '@wilson/interfaces';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { PipesModule } from '@wilson/pipes';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'wilson-general-settings-address',
  templateUrl: './general-settings-address.component.html',
  styleUrls: ['./general-settings-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    NzInputModule,
    FormsModule,
    ReactiveFormsModule,
    NzSelectModule,
    PipesModule,
    NzTooltipModule,
  ],
})
export class GeneralSettingsAddressComponent {
  @Input() form!: FormGroup<AddressDetails>;
  @Input({ required: true }) hasGeneralSettingsUpdatePermission!: boolean;
  @Output() changeAddress = new EventEmitter();

  onAddressChange(): void {
    this.changeAddress.emit();
  }
}
